import React, { useState } from "react";
import {
  DisableIcon,
  UserImg,
  UserProfileImg,
} from "../../../../../public/assets";
import { styled } from "styled-components";
import CheckBox from "../../../../components/CheckBox/Checkbox.component";
import { Hrule } from "../../../../components/AddUser/AddUserContainer";
import UserRoles from "./UserRoles";
import DisableUsersModal from "./DisableUsersModal";

interface UserprofileProps {
  isChecked: boolean;
  handleCheckboxChange: () => void;
  count: number;
  handleClickAction: (action: string) => void;
  clickedAction: string;
  roles: { type: string; name: string }[];
  onRoleChange: (role: { type: string; name: string }, index?: number) => void;
}

const SelectAllModal: React.FC<UserprofileProps> = ({
  isChecked,
  handleCheckboxChange,
  count,
  handleClickAction,
  clickedAction,
  roles,
  onRoleChange,
}) => {
  const [showDisableModal, setShowDisableModal] = useState(false);

  const handleDisableSubmit = () => {};

  const handleCloseDisableModal = () => {
    setShowDisableModal(false);
  };

  const selectModalItems = [
    {
      label: "Select All",
      imageSrc: "",
      hasCheckbox: true,
      alt: "Checkbox",
    },
    {
      label: "Reassign User Roles",
      imageSrc: "/assets/svg/user.svg",
      alt: "user",
    },
    {
      label: "Disable All",
      imageSrc: "/assets/svg/DisableIcon.svg",
      alt: "Disable",
    },
  ];

  return (
    <>
      <Hrule />
      <SelectAllModalWrapper>
        {selectModalItems?.map((item, index) => (
          <Entity key={index} onClick={() => {}}>
            {item.hasCheckbox ? (
              <>
                <CheckBox
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  width="20px"
                  height="20px"
                />
                <span onClick={() => handleClickAction(item.label)}>
                  {item.label}
                </span>
              </>
            ) : (
              <>
                {item.imageSrc && <img src={item.imageSrc} alt={item.alt} />}
                <span
                  onClick={() => {
                    if (item.label === "Disable All") {
                      setShowDisableModal(true);
                    } else {
                      handleClickAction(item.label);
                    }
                  }}
                >
                  {item.label}
                  {item.label === "Disable All" && `(${count})`}
                </span>
                {clickedAction === "Reassign User Roles" &&
                  clickedAction === item.label && (
                    <UserRoles onRoleChange={onRoleChange} roles={roles} />
                  )}
              </>
            )}
            {index < selectModalItems.length - 1 && <VerticalRule />}
          </Entity>
        ))}
      </SelectAllModalWrapper>
      {showDisableModal && (
        <DisableUsersModal
          onClose={handleCloseDisableModal}
          onSubmit={handleDisableSubmit}
        />
      )}
    </>
  );
};

export default SelectAllModal;

export const SelectAllModalWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;

  span {
    font-size: 0.875rem;
  }
  @media screen and (max-width: 767px) {
    overflow: auto;
    white-space: nowrap;
    gap: 2rem;
  }
`;

export const Entity = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  cursor: pointer;
`;
export const VerticalRule = styled.div`
  border-right: 1px solid #e8eaed;
  height: 1rem;
  margin: 0 2rem;
`;
